import { h, defineComponent, ref } from 'vue';
import { box, container, loader, logo } from '@/ui/components';
import * as qs from '@/ui/queryState';
import { renderForbiddenPage } from '@/ui/pages/error/ForbiddenPage';
import { impersonate } from '@/ui/auth/auth';
import { useSetBrowserLocale, useTask } from '@/ui/concerns';
import { pushRoute } from '@/ui/helpers';
import { LoggedInUser } from '@/entities/auth/loggedInUser';
import { t } from '@/ui/i18n/i18n';
import { router } from '@/ui/routes';

export const ImpersonatePage = defineComponent({
  name: 'ImpersonatePage',
  setup() {
    useSetBrowserLocale();

    const token = qs.string('token', '');

    const userName = ref<string>();

    if (token.value.length === 0) {
      return renderForbiddenPage;
    }

    // send record
    const impersonateTask = useTask(
      impersonate(token.value),
      (u: LoggedInUser) => {
        userName.value = u.name;
        pushRoute({ name: 'home' }, () => router.go(0));
      },
    );

    return function render() {
      return container(
        [
          logo(),
          box([
            loader('div', impersonateTask, [
              h('div', [
                t('auth.impersonation'),
                userName.value ?? null,
              ]),
            ]),
          ]),
        ],
      );
    };
  },
});
